module.exports = new __parcel__URL__("0l.63b0fd01.png").toString();